export default __webpack_public_path__ + "./fonts/pdf.df02c011.svg";